import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51034b39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ClientCard" }
const _hoisted_2 = {
  key: 0,
  class: "ClientCard__state"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__text" }, "Загрузка данных клиента...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__text text--failed" }, " Произошла ошибка при получении данных клиента ", -1))
const _hoisted_5 = {
  key: 1,
  class: "ClientCard__content"
}
const _hoisted_6 = { class: "content__name" }
const _hoisted_7 = { class: "content__phone" }
const _hoisted_8 = { class: "content__gender" }
const _hoisted_9 = { class: "content__wpstatus" }
const _hoisted_10 = { class: "content__information" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_12 = { class: "content__information" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 12H22.5",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5 2C15.0013 4.73835 16.4228 8.29203 16.5 12C16.4228 15.708 15.0013 19.2616 12.5 22C9.99872 19.2616 8.57725 15.708 8.5 12C8.57725 8.29203 9.99872 4.73835 12.5 2V2Z",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_14 = { class: "content__information" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_16 = { class: "content__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_ok_button = _resolveComponent("ok-button")!
  const _component_ok_wp_status = _resolveComponent("ok-wp-status")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.failed || !_ctx.client)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ], 64))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_ok_button, { onClick: _ctx.onReload }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.client)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" Нет данных по клиенту ")
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.client.fullName), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.client.phone), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.client.genderDescription), 1),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ok_wp_status, { enabled: _ctx.haveWhatsapp }, null, 8, ["enabled"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", null, _toDisplayString(_ctx.client.organizationTypeDescription), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", null, _toDisplayString(_ctx.client.speechLanguageDescription), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", null, _toDisplayString(_ctx.client.cityName), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: { path: '/oktell/create-order', query: _ctx.$route.query }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ok_button, { class: "OkButton--blue" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Сделать расчет ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
  ]))
}